import PropTypes from 'prop-types';
import { get } from 'core/libs/lodash';
import withTheme from 'core/hocs/withTheme';
import themePropTypes from 'core/utils/prop-types/theme';
import styles from './index.styl';

const LABELS = {
  expert: 'Эксперт',
};

function AuthorTypeLabel({ type, theme }) {
  const authorTypeTheme = get(theme, `controls.author.types.${type}`);

  if (!authorTypeTheme) return null;

  return (
    <span className={styles.type}>
      <style jsx>{`
        .${styles.type}
          font 11px/14px ${theme.fonts.nuance}
          background ${authorTypeTheme.background}
          border-radius ${authorTypeTheme.borderRadius}
          color ${authorTypeTheme.color}
          text-transform ${authorTypeTheme.textTransform}
          border ${authorTypeTheme.border}
      `}</style>
      {LABELS[type]}
    </span>
  );
}

const authorTypesContract = `{
  color,
  borderRadius,
  border,
  textTransform,
  background,
}`;

AuthorTypeLabel.propTypes = {
  /**
   * Тип автора
  */
  type: PropTypes.string.isRequired,
  /** @ignore */
  theme: themePropTypes(`{
    fonts: {
      nuance,
    },
    controls: {
      author: {
        types: {
          expert: ${authorTypesContract}
        },
      }
    },
  }`),
};

const AuthorTypeLabelWithHOCs = withTheme(AuthorTypeLabel);
AuthorTypeLabelWithHOCs.displayName = 'AuthorTypeLabel';

export default AuthorTypeLabelWithHOCs;
export { AuthorTypeLabel as StorybookComponent };
